export default class MouseBlockingUnderlay {
	/**
	 * @param parent
	 * @param cb
	 * @return {HTMLDivElement}
	 */
	static show(cb, parent = document.body) {
		const underlay = document.createElement('div');
		underlay.classList.add('mouse-blocking-overlay');
		parent.appendChild(underlay);
		underlay.addEventListener('click', (evt) => {
			evt.stopPropagation();
			underlay.remove();
			cb();
		})
		return underlay;
	}
}